var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg500Icon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 122,
    viewBox: "0 0 123 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4242_15629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5 122C95.1894 122 122.5 94.6894 122.5 61C122.5 27.3106 95.1894 0 61.5 0C27.8106 0 0.5 27.3106 0.5 61C0.5 94.6894 27.8106 122 61.5 122Z",
    fill: "#0079C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4995 5.75391C91.9629 5.75391 116.745 30.536 116.745 60.9995C116.745 91.4629 91.9629 116.245 61.4995 116.245C31.036 116.245 6.25391 91.4629 6.25391 60.9995C6.25391 30.536 31.036 5.75391 61.4995 5.75391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0103 25.5714H85.636V24.0383C85.6582 23.8335 85.637 23.6263 85.5739 23.4302C85.5107 23.2341 85.4069 23.0535 85.2694 22.9002C85.1318 22.7469 84.9634 22.6242 84.7753 22.5403C84.5872 22.4563 84.3834 22.4129 84.1774 22.4129C83.9714 22.4129 83.7677 22.4563 83.5796 22.5403C83.3915 22.6242 83.2231 22.7469 83.0855 22.9002C82.9479 23.0535 82.8442 23.2341 82.781 23.4302C82.7178 23.6263 82.6967 23.8335 82.7189 24.0383V25.5714H65.3801V19.4854C65.3801 17.8055 64.0181 17.583 62.3383 17.583C60.6584 17.583 59.2989 17.8055 59.2989 19.4854V25.5714H41.9552V24.0383C41.9775 23.8335 41.9563 23.6263 41.8931 23.4302C41.83 23.2341 41.7262 23.0535 41.5886 22.9002C41.451 22.7469 41.2827 22.6242 41.0945 22.5403C40.9064 22.4563 40.7027 22.4129 40.4967 22.4129C40.2907 22.4129 40.087 22.4563 39.8988 22.5403C39.7107 22.6242 39.5424 22.7469 39.4048 22.9002C39.2672 23.0535 39.1634 23.2341 39.1003 23.4302C39.0371 23.6263 39.0159 23.8335 39.0381 24.0383V25.5714H36.6639C35.5782 25.5714 35.5244 26.7622 35.5244 28.2318C35.5244 29.7013 35.5782 30.8946 36.6639 30.8946H48.8898L59.2989 41.2891V107.065C59.2989 108.747 65.3825 108.747 65.3825 107.065V41.2891L75.777 30.8946H88.0029C89.0886 30.8946 89.1424 29.7038 89.1424 28.2318C89.1424 26.7598 89.0959 25.5714 88.0103 25.5714ZM59.2989 39.1373L51.0562 30.8946H59.2989V39.1373ZM65.3825 39.1373V30.8946H73.6253L65.3825 39.1373Z",
    fill: "#0079C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.015 98.2867C69.8137 98.2867 38.7109 67.1987 38.7109 28.9854H41.6672C41.6672 65.5677 71.4299 95.3305 108.015 95.3305V98.2867Z",
    fill: "#0079C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4242_15629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500Icon);
export default __webpack_public_path__ + "static/media/500-Icon.7f608121781d31a924a005cec42c9da3.svg";
export { ForwardRef as ReactComponent };